import { MainPageHeader } from "main/components";
import React, { useEffect, useState } from "react";
import aboutusbanner from "main/assets/images/Images/About Us-Images/about-us-banner.png";
import Aboutbanner from "main/assets/images/Images/About Us-Images/About_us_banner.png";
import Section2Image from "main/assets/images/Images/About Us-Images/rooted-in-excellence1.svg";
import mobileleader from "main/assets/images/Images/About Us-Images/mobile_leader_img.svg";
import Section4Image from "main/assets/images/Images/About Us-Images/our-mission1.svg";
import Section3Image from "main/assets/images/Images/About Us-Images/image3.png";
import image2 from "main/assets/images/Images/About Us-Images/image2.png";
import Biren from "main/assets/images/Images/About Us-Images/birendra-sen-photo.png";
import Maskgroup from "main/assets/images/Images/About Us-Images/Mask-group.png";
import Maskgrouptest from "main/assets/images/Images/About Us-Images/Maskgrouptest.png";
import endtoend from "main/assets/images/Images/About Us-Images/end-to-end.png";
import AIbased from "main/assets/images/Images/About Us-Images/AI-based.png";
import supplychain from "main/assets/images/Images/About Us-Images/supply-chain.png";
import mechanisum from "main/assets/images/Images/About Us-Images/mechanisum.png";
import scenarioplanning from "main/assets/images/Images/About Us-Images/scenario-planning.png";
import technicianproductivity from "main/assets/images/Images/About Us-Images/technician-productivity.png";
import processreEngineering from "main/assets/images/Images/About Us-Images/process-reEngineering.png";
import content from "main/helpers/contentHelper.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

interface ABOUTDATA {
  title?: string;
  image?: string;
}

const AboutData: ABOUTDATA[] = [
  {
    title: "End-to-end visibility of demand and supply",
    image: endtoend,
  },
  {
    title: "AI-based decision making",
    image: AIbased,
  },
  {
    title: "Cognitive supply-chain",
    image: supplychain,
  },
  {
    title: "Early alert mechanism",
    image: mechanisum,
  },
  {
    title: "Scenario planning",
    image: scenarioplanning,
  },
  {
    title: "Technician productivity",
    image: technicianproductivity,
  },
  {
    title: "Process re-engineering",
    image: processreEngineering,
  },
];
export default function AboutUs() {
  const [data, setData] = useState<any>(undefined);
  const cards = data?.about?.section5?.card1;
  const [featureTelecoms, setFeatureTelecoms] = useState(cards);
  const [activetIndex, setActiveIndex] = useState(0);
  const [enter, setEnter] = useState(-1);
  useEffect(() => {
    setFeatureTelecoms(cards);
  }, [cards]);

  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const MouseEnter = (index) => {
    setEnter(index);
    setFeatureTelecoms(
      featureTelecoms.map((telecom: any, telindex: number) => {
        if (telindex === index) {
          return { ...telecom, selected: 1 };
        } else {
          return { ...telecom, selected: 0 };
        }
      })
    );
  };
  const MouseLeave = (index) => {
    setEnter(index);
    setFeatureTelecoms(
      featureTelecoms.map((telecom: any, telindex: number) => {
        return { ...telecom, selected: 0 };
      })
    );
  };
  // useeffects
  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  const [flippedCards, setFlippedCards] = useState(new Set());
  const handleClick = (id: number) => {
    setFlippedCards((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) newSet.delete(id);
      else newSet.add(id);
      return newSet;
    });
  };

  return (
    <>
      <div className="contact">
        <MainPageHeader
          backgroundImage={aboutusbanner}
          mobilebgImage={Aboutbanner}
          heading={data ? data?.about?.headerTitle : ""}
          description={data ? data?.about?.headerDesc : ""}
          descriptionClass="text-white-color font-family-roboto"
        />

        <div className="section7 font-family-roboto container py-60">
          <p className="text-primary1 font-28 font-family-roboto fonts-400 pb-40 line-32 about-heading">
            {data ? data?.about?.section5?.leaders?.title : ""}
          </p>
          {/* mobile */}
          <div className="container d-block  d-md-none">
            <div className="d-flex">
              <div className="col-4 w-40 pt-0">
                <div className="d-flex justify-content-end">
                  <img
                    className="wx-27 hx-21 text-right pt-1"
                    src={data?.about?.section5?.leaders?.quote1}
                    alt={data ? data?.about?.section5?.leaders?.quote1 : ""}
                  />
                </div>
                <img
                  className="wx-130 hx-130 pt-20"
                  id="mobileLeader"
                  src={mobileleader}
                  alt={data ? data?.about?.section5?.section4?.title : ""}
                />

                <div className="pt-20">
                  <div className="d-flex justify-content-start flex-column align-items-start">
                    <p className="text-primary1 font-family-roboto-flex font-13 fonts-800 line-21 pb-2 about-leader">
                      {data ? data?.about?.section5?.leaders?.name : ""}
                    </p>
                    <p className="text-grey font-12 font-family-roboto-flex fonts-400 line-18">
                      Business Head, BPS, TechM.
                    </p>
                  </div>
                  <div className="text-primary1 font-28 fonts-800 pb-10">
                    <a href="https://www.linkedin.com/in/birendra-sen-8546461">
                      <img
                        src={data?.about?.section5?.leaders?.image}
                        alt="linkedin"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-8 w-60">
                {/* <img
                className="wx-27 hx-21"
                src={data?.about?.section5?.leaders?.quote1}
                alt={data ? data?.about?.section5?.leaders?.quote1 : ""}
              /> */}
                <p className="text-black-90 font-family-roboto font-12 line-19 fonts-400 footer-subcontent pt-20">
                  Launched in September 2022, Yantr.ai is a cognitive AI
                  solution that optimizes field services through deep analytical
                  insights, decision-making support, and future-proof strategic
                  planning. The platform combines technology, data, and people
                  to automate, optimize, and improve experiences for field
                  service operations. It helps clients identify lags and create
                  a flawless field ecosystem through actionable insights and
                  recommendations.
                  {/* {data ? data?.about?.section5?.leaders?.desc : ""} */}
                </p>
                <div className="d-flex justify-content-end">
                  <img
                    className="wx-27 hx-21 text-right pt-1"
                    src={data?.about?.section5?.leaders?.quote2}
                    alt={data ? data?.about?.section5?.leaders?.quote2 : ""}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Website View */}
          <div className="d-none d-md-block">
            <div className="row">
              <div className="col-md-4">
                <img
                  className="wx-337 hx-400 "
                  src={Biren}
                  alt={data ? data?.about?.section5?.section4?.title : ""}
                />
              </div>
              <div className="col-md-8 ps-3 pt-20">
                <img
                  className="wx-70 hx-55 pb-2"
                  src={data?.about?.section5?.leaders?.quote1}
                  alt={data ? data?.about?.section5?.leaders?.quote1 : ""}
                />
                <p className="text-black-90 font-family-roboto font-18 line-24 fonts-400 footer-subcontent">
                  {data ? data?.about?.section5?.leaders?.desc : ""}
                </p>
                <div className="d-flex justify-content-end">
                  <img
                    className="wx-37 hx-27 text-right pt-1"
                    src={data?.about?.section5?.leaders?.quote2}
                    alt={data ? data?.about?.section5?.leaders?.quote2 : ""}
                  />
                </div>
                <div className="col-md-12 mt-40 d-flex flex-row gap-4">
                  <div className="border-gray-right d-flex justify-content-start flex-column align-items-start pr-26">
                    <p className="text-primary1 font-family-roboto-flex font-28 fonts-800 line-21 pb-2 about-leader">
                      {data ? data?.about?.section5?.leaders?.name : ""}
                    </p>
                    <p className="text-grey font-16 font-family-roboto-flex fonts-400 line-18 footer-subcontent">
                      {data ? data?.about?.section5?.leaders?.designation : ""}
                    </p>
                  </div>
                  <div className="text-primary1 font-28 fonts-800 pb-10">
                    <a href="https://www.linkedin.com/in/birendra-sen-8546461">
                      <img
                        src={data?.about?.section5?.leaders?.image}
                        alt="linkedin"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section2 container">
          <p className="d-flex header-color font-30 fonts-800 pb-20 font-family-roboto line-35 justify-content-center about-head">
            {data ? data?.about?.section1?.title : ""}
          </p>
          <p className="text-primary1 font-22 line-32 fonts-400 pb-20 text-center font-family-roboto about-subheading">
            {data ? data?.about?.section1?.desc : ""}
          </p>
        </div>
        <div className="section3 container font-family-roboto py-40">
          {/* Mobile View */}
          <div className="d-block  d-md-none">
            <div className="">
              <div className="col-md-5 p-0">
                <div className="d-flex col-md-12 flex-gap-20">
                  <div className="">
                    <img
                      className="w-100 pt-35"
                      src={Section3Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                    <img
                      className="w-100 pt-35 pl-60 h-140"
                      src={Section2Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                  </div>
                  <div className="col-md-6">
                    <img
                      className="w-100"
                      src={image2}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                    <img
                      className="w-100 pt-25 pr-80 h-185 w-50"
                      src={Section4Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                  </div>
                </div>
              </div>
              {/* Mobile View */}
              <div className="d-block  d-md-none">
                <div className="col-md-7 pl-10">
                  <p className="dark-header font-family-roboto font-24 fonts-800 pb-20 about-content">
                    {data ? data?.about?.section2?.title : ""}
                  </p>
                  <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-20 line-26 footer-subcontent2">
                    {data ? data?.about?.section2?.desc1 : ""}
                  </p>
                  <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-40 line-26 footer-subcontent2">
                    {data ? data?.about?.section2?.desc2 : ""}
                  </p>

                  <p className="dark-header font-24 font-family-roboto fonts-800 pb-20 footer-content">
                    {data ? data?.about?.section3?.title : ""}
                  </p>
                  <p className="text-black-90 font-18  font-family-roboto fonts-400 pb-40 line-26 footer-subcontent2">
                    {data ? data?.about?.section3?.desc : ""}
                  </p>

                  <div className="col-md-12">
                    <p className="dark-header font-24 fonts-800 pb-20 font-family-roboto footer-content">
                      {data ? data?.about?.section4?.title : ""}
                    </p>
                    {data?.about?.section4?.desc?.map(
                      (item: any, index: any) => {
                        return (
                          <>
                            <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                              {item.title}
                            </p>
                            <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-20 footer-subcontent2">
                              {item.desc}
                            </p>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
              {/* Website View */}
              <div className="d-none d-md-block">
                <div className="col-md-7 pl-40">
                  <p className="dark-header font-family-roboto font-24 fonts-800 pb-20 about-content">
                    {data ? data?.about?.section2?.title : ""}
                  </p>
                  <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-20 line-26 footer-subcontent2">
                    {data ? data?.about?.section2?.desc1 : ""}
                  </p>
                  <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-30 line-26 footer-subcontent2">
                    {data ? data?.about?.section2?.desc2 : ""}
                  </p>

                  <p className="dark-header font-24 font-family-roboto fonts-800 pb-20 footer-content">
                    {data ? data?.about?.section3?.title : ""}
                  </p>
                  <p className="text-black-90 font-18  font-family-roboto fonts-400 pb-30 line-26 footer-subcontent2">
                    {data ? data?.about?.section3?.desc : ""}
                  </p>

                  <div className="col-md-12">
                    <p className="dark-header font-24 fonts-800 pb-20 font-family-roboto footer-content">
                      {data ? data?.about?.section4?.title : ""}
                    </p>
                    {data?.about?.section4?.desc?.map(
                      (item: any, index: any) => {
                        return (
                          <>
                            <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                              {item.title}
                            </p>
                            <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-20 footer-subcontent2">
                              {item.desc}
                            </p>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Website View */}
          <div className="d-none d-md-block">
            <div className="row">
              <div className="col-md-5 p-0">
                <div className="d-flex col-md-12 flex-gap-20">
                  <div className="">
                    <img
                      className="w-100 pt-35"
                      src={Section3Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                    <img
                      className="w-100 pt-35 pl-60 h-140"
                      src={Section2Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                  </div>
                  <div className="col-md-6">
                    <img
                      className="w-100"
                      src={image2}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                    <img
                      className="w-100 pt-25 pr-80 h-185 w-50"
                      src={Section4Image}
                      alt={data ? data?.about?.section2?.title : ""}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-7 pl-40">
                <p className="dark-header font-family-roboto font-24 fonts-800 pb-20 about-content">
                  {data ? data?.about?.section2?.title : ""}
                </p>
                <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-20 line-26 footer-subcontent2">
                  {data ? data?.about?.section2?.desc1 : ""}
                </p>
                <p className="text-black-90 font-18 font-family-roboto fonts-400 pb-40 line-26 footer-subcontent2">
                  {data ? data?.about?.section2?.desc2 : ""}
                </p>

                <p className="dark-header font-24 font-family-roboto fonts-800 pb-20 footer-content">
                  {data ? data?.about?.section3?.title : ""}
                </p>
                <p className="text-black-90 font-18  font-family-roboto fonts-400 pb-40 line-26 footer-subcontent2">
                  {data ? data?.about?.section3?.desc : ""}
                </p>

                <div className="col-md-12">
                  <p className="dark-header font-24 fonts-800 pb-20 font-family-roboto footer-content">
                    {data ? data?.about?.section4?.title : ""}
                  </p>
                  {data?.about?.section4?.desc?.map((item: any, index: any) => {
                    return (
                      <>
                        <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                          {item.title}
                        </p>
                        <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-20 footer-subcontent2">
                          {item.desc}
                        </p>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid position-relative">
        <div className="bg-color-n">
          <p className="col-md-12 font-30 fonts-800 py-60 font-family-roboto text-white-color line-35 text-center w-100 garph-heading">
            Why Yantr.ai ?
          </p>
          {/* Mobile View */}
          <div className="d-block bg-color-n d-md-none">
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={0}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper customSwiper bg-color-n aboutus-swiper"
            >
              <div className="container px-40 bg-color-n overflow-x-auto">
                <div className="d-flex justify-content-between bg-color-n p-20">
                  {featureTelecoms?.map((card) => (
                    <SwiperSlide>
                      <div
                        className="col-md-6 col-12 col-lg-3 p-10 bg-color-n w-100"
                        key={card.id}
                        onClick={() => handleClick(card.id)}
                        style={{ width: "180px" }}
                      >
                        <div
                          className="flip-card"
                          style={{ height: "300px", width: "240px" }}
                        >
                          <div
                            className={`flip-card-inner ${
                              flippedCards.has(card.id) ? "flipped" : ""
                            }`}
                          >
                            <div className="flip-card-front">
                              <div className="h-100 w-100">
                                <div className="content-wrap front-bg">
                                  <div className="d-flex flex-column justify-content-center px-5 g-3 h-100">
                                    <div className="d-flex flex-column mb-2">
                                      <h6
                                        className="text-center fonts-600 justify-content-cente text-white font-family-roboto"
                                        style={{
                                          fontSize: "24px",
                                          lineHeight: "30px",
                                          letterSpacing: "0.25px",
                                        }}
                                      >
                                        {card.title}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flip-card-back">
                              <div className="h-100">
                                <div className="content-wrap back-bg">
                                  <div className="d-flex flex-column justify-content-center h-100 px-1">
                                    <div className="d-flex flex-column m-3">
                                      <h6
                                        className="text-center text-white font-family-roboto"
                                        style={{
                                          fontSize: "20px",
                                          lineHeight: "30px",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {card.title}
                                      </h6>
                                      <div
                                        className={`desc-wrapper ${
                                          flippedCards.has(card.id)
                                            ? "slide-up"
                                            : ""
                                        }`}
                                      >
                                        <p
                                          className="text-center text-white fw-light mt-3 font-family-roboto"
                                          style={{
                                            fontSize: "18px",
                                            lineHeight: "22px",
                                            letterSpacing: "0.5px",
                                          }}
                                        >
                                          {card.desc}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </div>
              </div>
            </Swiper>
          </div>
          {/* Website View */}
          <div className="d-none d-md-block">
            <div className="container px-40">
              <div className="d-flex justify-content-between">
                {featureTelecoms?.map((item: any, index: any) => (
                  <div className="col-md-6 col-sm-12 col-lg-3 p-10">
                    <div
                      className="d-flex justify-content-center card-column"
                      key={index}
                    >
                      <div className="card-container">
                        <div className="d-flex flex-column h-100">
                          <div className="card-body justify-content-center">
                            <p className="card-title-about text-center text-white font-24 px-16 justify-content-center font-family-roboto fonts-600 line-30">
                              {item?.title}
                            </p>
                            <p className="card-desc text-center text-white px-3 font-18 line-24 fonts-400 justify-content-center font-family-roboto">
                              {item?.desc}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-block d-md-none text-center">
                      <button
                        key={index}
                        className={
                          index === activetIndex
                            ? "active p-1"
                            : "banner-slider p-1"
                        }
                        onClick={() => goToSlide(index)}
                      ></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Mobile View */}
        <div className="row d-block d-md-none">
          <div className="bg-color-n hx-340"></div>
          <div className="container px-40 mt-n-290 paddingX">
            <div className="p-0">
              <div
                style={{
                  backgroundImage: "url(" + Maskgrouptest + ")",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="radius_47 col-md-12 operation-grid pt-40 justify-content-end align-items-center justify-content-center px-0 radius-25 overflow-hidden"
              >
                <div
                  style={{
                    background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                  }}
                  className="row col-md-12 col-sm-12 col-12 h-100 d-flex justify-content-between flex-row w-100 hx-200"
                >
                  {AboutData.map((val, index) => (
                    <div className="f-flex col-md-6 col-sm-12 col-lg-3">
                      <div
                        className="row display-about align-items-center justify-content-center align-self-center"
                        key={index}
                      >
                        <img
                          className="wx-110 hx-80 mb-20"
                          src={val?.image}
                          alt="background will be here"
                        />
                        <h1 className="text-white-color text-center font-family-roboto fonts-400 font-16 line-18 mx-14 mb-30">
                          {val?.title}
                        </h1>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Website View */}
        <div className="d-none d-md-block">
          <div className="bg-color-n hx-340"></div>
          <div className="container px-40 mt-n-290 paddingX">
            <div className="p-20">
              <div
                style={{
                  backgroundImage: "url(" + Maskgroup + ")",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="col-md-12 operation-grid justify-content-center align-items-center justify-content-center px-0 mobile-radius radius-24  overflow-hidden"
              >
                <div
                  style={{
                    background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                  }}
                  className="row col-md-12 col-sm-12 col-12 h-100 py-40 d-flex align-items-center justify-content-center w-100 px-30"
                >
                  {AboutData.map((val, index) => (
                    <div className=" col-md-6 col-sm-12 col-lg-3 align-items-center justify-content-center align-self-center">
                      <div
                        className="d-flex flex-column display-about align-items-center justify-content-center align-self-center"
                        key={index}
                      >
                        <img
                          className="align-items-center justify-content-center align-self-center pb-10 pt-20"
                          src={val?.image}
                          alt="background will be here"
                        />
                        {index === 4 ? (
                          <h1 className="text-white-color text-center font-family-roboto fonts-400 font-20 line-23 mx-30 mb-30">
                            {val?.title}
                          </h1>
                        ) : (
                          <h1 className="text-white-color text-center font-family-roboto fonts-400 font-20 line-23 mx-10 mb-30">
                            {val?.title}
                          </h1>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-relative topx-10 container font-family-roboto container-fluid mt-40">
        <div className="col-md-12 col-sm-12 col-lg-12 p-10">
          <p className="dark-header font-28 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
            {data ? data?.about?.section5?.leaders?.contact?.title : ""}
          </p>
          <p className="text-black-90 font-16 line-20 fonts-400 pb-40 font-family-roboto footer-subcontent2">
            {data ? data?.about?.section5?.leaders?.contact?.desc : ""}
          </p>
          <p className="dark-header font-28 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
            {data ? data?.about?.section5?.leaders?.contact?.desc2 : ""}
          </p>
          <div className="d-flex justify-content-start align-items-center flex-row gap-3 pb-60 font-family-roboto footer-subcontent2">
            <img
              className="hx-14 text-right"
              src={data?.about?.section5?.leaders?.contact?.icon}
              alt={data ? data?.about?.section5?.leaders?.contact?.icon : ""}
            />
            <p className="text-black-90 font-18 line-24 fonts-400 footer-subcontent2">
              {data ? data?.about?.section5?.leaders?.contact?.email : ""}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
